module.exports = __webpack_public_path__ + "img/down_btn.ac76eb01.svg";